<template>
  <v-text-field
      ref="v_number_field"
      v-bind="$attrs"
      dense
      outlined
      type="number"
      class="no-spin large-input"
      :clearable="clearable"
      @input="onInput"
      @keydown.enter="onEnter()"
      :roles="roles"
      autofocus
      :filled="filled || readonly"
      :readonly="readonly"
  >
    <template v-slot:prepend>
      <slot name="prepend"></slot>
    </template>
  </v-text-field>
</template>

<script>

export default {
  name: 'CommonFieldNumber',
  inheritAttrs: false,
  props: {
    clearable: {default: false},
    roles: {default() {return []}},
    enterInput: {default: null},
    readonly: {default: false},
    filled: {default: false},
  },

  components: {},

  computed: {},

  methods: {
    onEnter() {
      this.$emit('enter')
      if (!!this.enterInput)
        this.enterInput()
    },
    onInput(event) {
      // console.log('onInput', event)
      if (event === '')
        this.$emit('input', null)
      else
        this.$emit('input', event)
    },
  },

  async mounted() {
  },

  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
